'use client';
import type { JSX } from 'react';

import { AuthStoreProvider } from '@/features/authentication/providers/AuthStoreProvider';
import type { AuthState } from '@/features/authentication/stores/authStore';
import { IssuesStoreProvider } from '@/features/issues/providers/IssuesStoreProvider';
import { PermissionsStoreProvider } from '@/features/permissions/providers/PermissionsProvider';
import type { PermissionsState } from '@/features/permissions/stores/permissionsStore';
import { RegexPatternsStoreProvider } from '@/features/regexPatterns/providers/RegexPatternsProvider';
import type { RegexPatternsState } from '@/features/regexPatterns/stores/regexPatternsStore';
import { ServiceRemindersStoreProvider } from '@/features/serviceReminders/providers/ServiceRemindersStoreProvider';
import { SystemEnumsStoreProvider } from '@/features/systemEnums/providers/SystemEnumsProvider';
import type { SystemEnumsState } from '@/features/systemEnums/stores/systemEnumsStore';
import { VehicleAssignmentStoreProvider } from '@/features/vehicleAssignments/providers/VehicleAssignmentStoreProvider';

type StoresInitializerProps = {
    children: React.ReactNode;
    authState?: AuthState;
    systemEnumsState?: SystemEnumsState;
    permissionsState?: PermissionsState;
    regexPatternsState?: RegexPatternsState;
};

export default function StoresInitializer({
    children,
    authState,
    systemEnumsState,
    permissionsState,
    regexPatternsState,
}: StoresInitializerProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <SystemEnumsStoreProvider systemEnumsState={systemEnumsState}>
            <RegexPatternsStoreProvider regexPatternsState={regexPatternsState}>
                <VehicleAssignmentStoreProvider>
                    <ServiceRemindersStoreProvider>
                        <IssuesStoreProvider>
                            <AuthStoreProvider authState={authState}>
                                <PermissionsStoreProvider permissionsState={permissionsState}>{children}</PermissionsStoreProvider>
                            </AuthStoreProvider>
                        </IssuesStoreProvider>
                    </ServiceRemindersStoreProvider>
                </VehicleAssignmentStoreProvider>
            </RegexPatternsStoreProvider>
        </SystemEnumsStoreProvider>
    );
}
